var map = {
	"./1/AugmintReserves_DEPLOYS.json": 666,
	"./1/Exchange_DEPLOYS.json": 667,
	"./1/FeeAccount_DEPLOYS.json": 668,
	"./1/InterestEarnedAccount_DEPLOYS.json": 669,
	"./1/LoanManager_DEPLOYS.json": 670,
	"./1/Locker_DEPLOYS.json": 671,
	"./1/Migrations_DEPLOYS.json": 672,
	"./1/MonetarySupervisor_DEPLOYS.json": 673,
	"./1/PreTokenProxy_DEPLOYS.json": 674,
	"./1/PreToken_DEPLOYS.json": 675,
	"./1/Rates_DEPLOYS.json": 676,
	"./1/StabilityBoardProxy_DEPLOYS.json": 677,
	"./1/TokenAEur_DEPLOYS.json": 678,
	"./4/AugmintReserves_DEPLOYS.json": 679,
	"./4/Exchange_DEPLOYS.json": 680,
	"./4/FeeAccount_DEPLOYS.json": 681,
	"./4/InterestEarnedAccount_DEPLOYS.json": 682,
	"./4/LoanManager_DEPLOYS.json": 683,
	"./4/Locker_DEPLOYS.json": 684,
	"./4/Migrations_DEPLOYS.json": 685,
	"./4/MonetarySupervisor_DEPLOYS.json": 686,
	"./4/PreTokenProxy_DEPLOYS.json": 687,
	"./4/PreToken_DEPLOYS.json": 688,
	"./4/Rates_DEPLOYS.json": 689,
	"./4/StabilityBoardProxy_DEPLOYS.json": 690,
	"./4/TokenAEur_DEPLOYS.json": 691,
	"./999/AugmintReserves_DEPLOYS.json": 692,
	"./999/Exchange_DEPLOYS.json": 693,
	"./999/FeeAccount_DEPLOYS.json": 694,
	"./999/InterestEarnedAccount_DEPLOYS.json": 695,
	"./999/LoanManager_DEPLOYS.json": 696,
	"./999/Locker_DEPLOYS.json": 697,
	"./999/Migrations_DEPLOYS.json": 698,
	"./999/MonetarySupervisor_DEPLOYS.json": 699,
	"./999/PreTokenProxy_DEPLOYS.json": 700,
	"./999/PreToken_DEPLOYS.json": 701,
	"./999/Rates_DEPLOYS.json": 702,
	"./999/StabilityBoardProxy_DEPLOYS.json": 703,
	"./999/TokenAEur_DEPLOYS.json": 704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 665;